import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { startCase } from 'lodash/string';
import Form from '../../../../../components/Form';
import Input from '../../../../../components/Input';
import InputRestrictMarkup from '../../../../../components/InputRestictMarkup';
import WYSIWYG from '../../../../../components/WYSIWYG';
import messages from '../messages';
import elementIds from '../elementIds';
import FieldError from '../FieldError';
import '../styles.css';

const ProfileAlumniForm = ({ personsName, _class, hometown, major, quote, body, errors, onChange, formatMessage, type }) => (
  <React.Fragment>
    <Form.Field required error={errors.personsName} styleName="form-field name-field">
      <label className="form-label" htmlFor={elementIds.personsName}>
        <FormattedMessage {...messages.persons_name} />
      </label>
      <Input
        styleName="form-input"
        type="text"
        id={elementIds.personsName}
        aria-invalid={errors.personsName}
        aria-required="true"
        name="personsName"
        value={personsName}
        onChange={onChange}
        fluid
      />
      {errors.personsName && <FieldError message={messages.invalid_persons_name} />}
    </Form.Field>
    <Form.Field required error={errors.graduation_year} styleName="form-field">
      <label className="form-label" htmlFor={elementIds._class}>
        <FormattedMessage {...messages.graduation_year} />
      </label>
      <Input
        styleName="form-input"
        type="text"
        id={elementIds._class}
        aria-invalid={errors.graduation_year}
        aria-required="true"
        name="_class"
        value={_class}
        onChange={onChange}
        fluid
      />
      {errors.graduation_year && <FieldError message={messages.invalid_graduation_year} />}
    </Form.Field>
    <Form.Field error={errors.hometown} styleName="form-field">
      <label className="form-label" htmlFor={elementIds.hometown}>
        <FormattedMessage {...messages.hometown} />
      </label>
      <Input
        styleName="form-input"
        type="text"
        id={elementIds.hometown}
        aria-invalid={errors.hometown}
        aria-required="false"
        name="hometown"
        value={hometown}
        placeholder={formatMessage(messages.hometown_placeholder)}
        onChange={onChange}
        fluid
      />
      {errors.hometown && <FieldError message={messages.invalid_hometown} />}
    </Form.Field>
    <Form.Field required error={errors.major} styleName="form-field">
      <label className="form-label" htmlFor={elementIds.major}>
        <FormattedMessage {...messages.major} />
      </label>
      <Input
        styleName="form-input"
        type="text"
        id={elementIds.major}
        aria-invalid={errors.major}
        aria-required="true"
        name="major"
        value={major}
        placeholder={formatMessage(messages.major_placeholder)}
        onChange={onChange}
        fluid
      />
      {errors.major && <FieldError message={messages.invalid_major} />}
    </Form.Field>
    <Form.Field required error={errors.quote} styleName="form-field">
      <label className="form-label" htmlFor={elementIds.quote}>
        <FormattedMessage {...messages.quote} />
      </label>
      <InputRestrictMarkup
        styleName="form-input"
        type="text"
        id={elementIds.quote}
        aria-invalid={errors.quote}
        aria-required="true"
        name="quote"
        value={quote}
        placeholder={formatMessage(messages.quote_placeholder)}
        onChange={onChange}
        fluid
      />
      {errors.quote && <FieldError message={messages.invalid_quote} />}
    </Form.Field>
    <Form.Field required error={errors.body} styleName="form-field body">
      <label className="form-label" htmlFor={elementIds.body}>
        <FormattedMessage values={{ type: startCase(type) }} {...messages.about_alumnus} />
      </label>
      <WYSIWYG
        className="edit-modal-wysiwyg-container"
        styleName="form-wysiwyg"
        id={elementIds.body}
        aria-invalid={errors.body}
        aria-required="true"
        name="body"
        type="textarea"
        limit={0}
        mode="extended"
        value={body}
        onChange={onChange}
        placeholder={formatMessage(messages.about_placeholder)}
        fluid
      />
      {errors.body && <FieldError message={messages.invalid_about_alumnus} />}
    </Form.Field>
  </React.Fragment>
);

ProfileAlumniForm.propTypes = {
  personsName: PropTypes.string.isRequired,
  _class: PropTypes.string.isRequired,
  hometown: PropTypes.string.isRequired,
  major: PropTypes.string.isRequired,
  quote: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  errors: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  formatMessage: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default ProfileAlumniForm;
